export default "__VITE_ASSET__CRf_lC$A__"